import NextImage from 'next/image'

import type { Country, CountryNode } from '@twisto/api-graphql'
import {
  SelectableListItem,
  SelectableListItemIcon,
  SelectableListItemText,
} from '@twisto/components/molecules/selectable-list'
import { CheckmarkFilledIcon, ChevronRightIcon } from '@twisto/icons'

import * as styles from './country-of-birth-list-item.styles'

type Props = {
  country: Pick<
    CountryNode,
    'code' | 'nameTranslated' | 'nameEnglish' | 'flagImage'
  >
  selected?: boolean
  showFlag?: boolean
  onSubmit: (countryCode: Country) => void
}

export const CountryOfBirthListItem = ({
  country,
  selected = false,
  showFlag = true,
  onSubmit,
}: Props) => (
  <SelectableListItem
    key={country.code}
    data-testid="option-selection-item"
    endAdornment={
      selected ? (
        <CheckmarkFilledIcon color="primary" size="24" />
      ) : (
        <ChevronRightIcon color="gray" size="24" />
      )
    }
    state={selected ? 'active' : undefined}
    onSubmit={() => onSubmit(country.code)}
  >
    <SelectableListItemText css={styles.optionSelect}>
      <>
        {showFlag && (
          <SelectableListItemIcon>
            <NextImage
              alt={country.nameEnglish}
              css={styles.flag}
              height="24"
              src={country.flagImage}
              width="24"
            />
          </SelectableListItemIcon>
        )}
        {country.nameTranslated}
      </>
    </SelectableListItemText>
  </SelectableListItem>
)
